var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudyLightRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-lightrain",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7,12.8c0.3,0,0.5,0.1,0.5,0.3v2.5c0,0.2-0.2,0.3-0.5,0.3s-0.5-0.1-0.5-0.3v-2.5C6.2,12.9,6.4,12.8,6.7,12.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8,8c-0.2,0-0.4,0-0.6,0.1C9.5,6.7,8,5.8,6.3,5.8c-2.5,0-4.5,2-4.5,4.5c0,2.1,1.5,3.9,3.5,4.4v-1.2         C4,13,3,11.8,3,10.2c0-1.9,1.5-3.4,3.4-3.4c1.6,0,2.9,1.1,3.3,2.6c0.4-0.2,0.8-0.4,1.2-0.4c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2         c-0.5,0-1.7,0-2.7,0v1.1c1.1,0,2.3,0,2.7,0c1.9,0,3.4-1.5,3.4-3.4C14.2,9.5,12.7,8,10.8,8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudyLightRain);
export default __webpack_public_path__ + "static/media/cloudyLightRain.f78a57dbc6cd016e627f459b505443b0.svg";
export { ForwardRef as ReactComponent };